<mat-dialog-content role="dialog" #alertMessage aria-labelledby="message" aria-modal="true" >
  <div class="mat-typography"   id="message" >
    <p aria-hidden="true" > {{ content.message }}</p>
    <span  [attr.aria-label]="content.convertedTimeMessage"></span>
</div>
  <nsc-spacer size="md"></nsc-spacer>
  
  <div class="nsc-form-actions">
    <button
      mat-raised-button
      class="nsc-button"
      color="primary"
      type="button"
      (click)="resetCountdown()">OK</button>
  </div>
</mat-dialog-content>
